<div class="community-home">
  <ng-container
    [ngTemplateOutlet]="home"
    [ngTemplateOutletContext]="{ $implicit: userService.user$ | async }"></ng-container>
</div>

<ng-template
  #home
  let-user>
  <div class="community-home__post--new">
    <div class="community-home__post--new__avatar">
      <a
        [avatar]="{ user: user, imgSize: '48px', size: 'small' }"
        [routerLink]="user | slug"
        [attr.aria-label]="user | userName"></a>
      <span
        ><strong>{{ 'community-home.hello' | i18next }}{{ user ? ' ' + (user | userName: true) : '' }}</strong
        >, {{ 'community-home.title' | i18next }}</span
      >
    </div>
    <div class="community-home__post--new__buttons">
      <button
        class="mat-rainbow rounded"
        mat-flat-button
        [disabled]="createDisabled"
        (click)="onCreateClick()">
        <sharry-icon
          name="note-pencil"
          type="phosphor"
          svgClass="svg-icon"></sharry-icon>
        {{ 'community-home.button.create' | i18next }}
      </button>
    </div>
  </div>
  <div class="community__head">
    <div
      #scroll
      class="community__head__tab"
      id="scroll">
      <a
        [routerLink]="'community' | routeTranslate"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
        [state]="{ trigger: 'popstate' }"
        >{{ 'community-home.community' | i18next }}</a
      >
      <a
        [routerLink]="'community/my-posts' | routeTranslate"
        [routerLinkActive]="'active'"
        [state]="{ trigger: 'popstate' }"
        >{{ 'community-home.my-posts' | i18next }}</a
      >
    </div>
  </div>
  <router-outlet></router-outlet>
  <button
    mat-flat-button
    color="secondary"
    class="community-home__create-post sharry-big rounded mat-rainbow"
    (click)="onCreateClick()">
    <sharry-icon
      name="note-pencil"
      type="phosphor"
      svgClass="community-home__create-post__icon"></sharry-icon>
    <span class="is-not-mobile-not-ipad bold">{{ 'community-home.button.create' | i18next }}</span>
  </button>
</ng-template>
